import * as DG from 'datagrok-api/dg';

import {category, test} from '@datagrok-libraries/test/src/test';

category('_first', () => {
  /** The first test of the package to evaluate problems with imports. */
  test('_first', async () => {
  });
});
